module.exports = __webpack_public_path__ + "static/media/hugeicons--ai-magic.0fa17952.svg";